import { Component, OnInit, Input } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';

@Component({
  selector: 'app-key-indicator',
  templateUrl: './key-indicator.component.html',
  styleUrls: ['./key-indicator.component.css']
})
export class KeyIndicatorComponent implements OnInit {

  constructor(private workspaceService: WorkspaceService) { }

  private componentId: string;
  private kpiCardObject:any;
  isBusy: boolean = false;
  keyIndicatorArrays: KeyIndicatorObjects[] = [];

  @Input() set setComponentId(id:string){
    this.componentId = id;
    this.refreshKPI();
  }

  ngOnInit() {
    this.isBusy = true;
    setTimeout(()=>{
      if (!this.componentId){
        this.isBusy = false;
      }
    }, 15000)
  }

  refreshKPI(){
    if (this.componentId){
      this.workspaceService.getKpiCard(this.componentId).subscribe(result => {
        this.kpiCardObject = JSON.parse(result);
        if (result){
          for (let key in this.kpiCardObject.KeyIndicatorObjects) {
            this.keyIndicatorArrays.push(this.kpiCardObject.KeyIndicatorObjects[key]);
          }
        }
        this.isBusy = false;
      }, error => {
        this.isBusy = false
      })
    }
  }
}

export class KeyIndicatorObjects {
  DefaultColour: string;
  DisplayColour: string;
  DisplayFormat: string;
  DisplayLabel: string;
  DisplayValue: string;
  FilterCriteria: string;
  FilterType: string;
  FilterValue: string;
  KeyIndicatorId: string;
  LowerBoundColour: string;
  LowerBoundValue: string;
  Name: string;
  ReportFieldAction: string;
  ReportFieldName: string;
  ReportId: string;
  UpperBoundColour: string;
  UpperBoundValue: string;
  WithinBoundsColour: string;
}
